import React from 'react';

/**
 * App-wide error boundary. Catches render/runtime errors in the React tree
 * and shows a friendly recovery screen instead of a blank white page.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Log for debugging; in production this could be sent to a monitoring service.
    console.error('Unhandled UI error:', error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  handleHome = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/';
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{
        minHeight: '100vh', display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center', padding: '2rem',
        textAlign: 'center', fontFamily: "'Poppins', 'Inter', sans-serif",
        background: 'linear-gradient(135deg,#0F0F1A 0%,#1E1B4B 100%)', color: '#fff',
      }}>
        <div style={{
          width: 72, height: 72, borderRadius: '50%', background: 'rgba(239,68,68,0.18)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.5rem',
        }}>
          <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#f87171"
            strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
        </div>
        <h1 style={{ fontSize: '1.6rem', fontWeight: 800, margin: '0 0 0.5rem' }}>
          Something went wrong
        </h1>
        <p style={{ color: 'rgba(255,255,255,0.65)', fontSize: '0.95rem', maxWidth: 440, margin: '0 0 1.75rem', lineHeight: 1.6 }}>
          An unexpected error occurred while rendering this page. You can reload the page or head back to the home screen.
        </p>
        <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap', justifyContent: 'center' }}>
          <button onClick={this.handleReload} style={{
            padding: '0.8rem 1.6rem', borderRadius: 12, border: 'none', cursor: 'pointer',
            background: '#7c3aed', color: '#fff', fontWeight: 700, fontSize: '0.9rem',
            fontFamily: 'inherit',
          }}>
            Reload Page
          </button>
          <button onClick={this.handleHome} style={{
            padding: '0.8rem 1.6rem', borderRadius: 12, cursor: 'pointer',
            background: 'rgba(255,255,255,0.12)', color: '#fff', fontWeight: 700, fontSize: '0.9rem',
            border: '1px solid rgba(255,255,255,0.2)', fontFamily: 'inherit',
          }}>
            Go Home
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
